/**
 * Baumdiagramm einfügen oder – steht der Cursor in einem – bearbeiten.
 * Gemeinsam für den großen Editor und den Hausaufgaben-Dialog (`MdField`).
 * Der eigentliche Editor lädt erst hier nach.
 */

import { findTreeAt } from "./treeDiagram";
import type { MdField } from "./field";

export function openTreeFor(field: MdField): void {
  const found = findTreeAt(field.value, field.selectionStart);
  void import("./treeEditor").then(({ openTreeEditor }) =>
    openTreeEditor({
      initial: found?.data,
      onSave: (md) => {
        field.focus();
        if (found) {
          field.setSelectionRange(found.start, found.end);
          field.insert(md);
        } else {
          field.insert(`\n\n${md}\n\n`);
        }
        field.emitInput();
      },
    })
  );
}
